import React from 'react';

import HandshakeIcon from '@mui/icons-material/Handshake';
import { Alert, AlertTitle, Box } from '@mui/material';

import PartnerEarnWizard from './PartnerEarnWizard';

export default function PartnerEarnPage() {
  return (
    <Box>
      <Alert icon={<HandshakeIcon />} severity="info" sx={{ mb: 3 }}>
        <AlertTitle>Earn as a Partner</AlertTitle>
        Credit Société points as a selected earn partner. Amounts follow that partner’s limits and show as that partner
        on the member activity.
      </Alert>
      <PartnerEarnWizard />
    </Box>
  );
}
